import { Skeleton } from "@mui/material"
import { ComponentProps } from "react";

const SkeletonInput = (props: { width?: string } & ComponentProps<typeof Skeleton>) => {
    const { width = '100%', ...rest } = props;

    return <Skeleton height={50} width={width} variant="rounded" {...rest}></Skeleton>
}

export default SkeletonInput;